/* eslint-disable import/no-dynamic-require */
const config = require(`./${process.env.REACT_APP_CLIENT_CODE || process.env.REACT_APP_MODE}`);
export default config.default;
